export default __webpack_public_path__ + "static/media/toggle.6cf529fc.svg";